<template>
  <keep-alive>
    <router-view :key="$route.fullPath"/>
  </keep-alive>
</template>


<script>

export default {
  name: "lightVisit",
  components: {},
  computed: {


  }
}
</script>

<style scoped lang="scss">
</style>
